// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --background-color: rgb(126, 186, 255);
  --border-color: rgb(126, 186, 255);
  --brand-blue: rgb(54, 151, 235);
  --brand-red: rgb(223, 79, 60);
}

button {
  background-color: transparent;
  border: 0;
  padding: 0;
}

button.intake-back a, button.intake-back a:hover {
  --button-color: rgb(211, 211, 211);
  background-color: transparent;
  border-color: var(--button-color);
  color: var(--button-color);
}

button.intake-back a:hover {
  background-color: rgb(75, 89, 103);
}

button.intake-continue a:hover {
  filter: brightness(1.05);
}


button.intake-continue a, button.intake-continue a:hover {
  --background-color: rgb(54, 151, 235);
  background-color: var(--background-color);
  border-color: var(--background-color);
}

button.intake-continue a:hover {
  filter: brightness(1.05);
}

button.save-continue a {
  background-color: rgb(0, 168, 155);
  border-color: rgb(0, 168, 155);
  color: rgb(255, 255, 255);
}

button a {
  background-color: rgb(53, 151, 236);
  border: 1px solid rgb(53, 151, 236);
  border-radius: 4px;
  box-shadow: none;
  color: rgb(255, 255, 255);
  display: block;
  height: 38px;
  font-size: 15px;
  line-height: 1.5;
  min-width: 74px;
  padding: 6px 20px;
  text-align: center;
  -webkit-user-select: none;
          user-select: none;
  vertical-align: middle;
  width: 100%;
}

button a:active {
  background-color: rgb(126, 186, 255);
  border-color: rgb(126, 186, 255);
}

button a:hover {
  background-color: rgb(31, 188, 176);
  border-color: rgb(31, 188, 176);
  text-decoration: none;
}

button.disabled a {
  background-color: rgb(255, 255, 255);
  color: rgb(53, 151, 236)
}

.action a {
  background-color: rgb(2, 168, 155);
  border-color: rgb(2, 168, 155);
}

.action a:active {
  background-color: rgb(94, 206, 197);
  border-color: rgb(94, 206, 197);
}

.action a:hover {
  background-color: rgb(31, 188, 176);
  border-color: rgb(31, 188, 176);
}

.intake-save a {
  --brand-red: rgb(223, 79, 60);
  background-color: var(--brand-red);
  border-color: var(--brand-red);
}

.intake-save a:active {
  --brand-red: rgb(223, 79, 60);
  background-color: var(--brand-red);
  border-color: var(--brand-red);
  filter: brightness(1.05);
}

.intake-save a:hover {
  --brand-red: rgb(223, 79, 60);
  background-color: var(--brand-red);
  border-color: var(--brand-red);
  filter: brightness(1.1);
}

.other a {
  background-color: rgb(48, 62, 78);
  border: 1px solid rgb(48, 62, 76);
}

.other a:active {
  background-color: rgb(84, 98, 116);
  border-color: rgb(84, 98, 116);
}

.other a:hover {
  background-color: rgb(67, 81, 99);
  border-color: rgb(67, 81, 99);
}

.reset a {
  background-color: rgb(223, 79, 60);
  border-color: rgb(223, 79, 60);
}

.reset a:active {
  background-color: rgb(247, 126, 116);
  border-color: rgb(247, 126, 116);
}

.reset a:hover {
  background-color: rgb(237, 103, 93);
  border-color: rgb(237, 103, 93);
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/buttons/button-basic/button-basic.component.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC;AACF;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC","sourcesContent":[":root {\n  --background-color: rgb(126, 186, 255);\n  --border-color: rgb(126, 186, 255);\n  --brand-blue: rgb(54, 151, 235);\n  --brand-red: rgb(223, 79, 60);\n}\n\nbutton {\n  background-color: transparent;\n  border: 0;\n  padding: 0;\n}\n\nbutton.intake-back a, button.intake-back a:hover {\n  --button-color: rgb(211, 211, 211);\n  background-color: transparent;\n  border-color: var(--button-color);\n  color: var(--button-color);\n}\n\nbutton.intake-back a:hover {\n  background-color: rgb(75, 89, 103);\n}\n\nbutton.intake-continue a:hover {\n  filter: brightness(1.05);\n}\n\n\nbutton.intake-continue a, button.intake-continue a:hover {\n  --background-color: rgb(54, 151, 235);\n  background-color: var(--background-color);\n  border-color: var(--background-color);\n}\n\nbutton.intake-continue a:hover {\n  filter: brightness(1.05);\n}\n\nbutton.save-continue a {\n  background-color: rgb(0, 168, 155);\n  border-color: rgb(0, 168, 155);\n  color: rgb(255, 255, 255);\n}\n\nbutton a {\n  background-color: rgb(53, 151, 236);\n  border: 1px solid rgb(53, 151, 236);\n  border-radius: 4px;\n  box-shadow: none;\n  color: rgb(255, 255, 255);\n  display: block;\n  height: 38px;\n  font-size: 15px;\n  line-height: 1.5;\n  min-width: 74px;\n  padding: 6px 20px;\n  text-align: center;\n  user-select: none;\n  vertical-align: middle;\n  width: 100%;\n}\n\nbutton a:active {\n  background-color: rgb(126, 186, 255);\n  border-color: rgb(126, 186, 255);\n}\n\nbutton a:hover {\n  background-color: rgb(31, 188, 176);\n  border-color: rgb(31, 188, 176);\n  text-decoration: none;\n}\n\nbutton.disabled a {\n  background-color: rgb(255, 255, 255);\n  color: rgb(53, 151, 236)\n}\n\n.action a {\n  background-color: rgb(2, 168, 155);\n  border-color: rgb(2, 168, 155);\n}\n\n.action a:active {\n  background-color: rgb(94, 206, 197);\n  border-color: rgb(94, 206, 197);\n}\n\n.action a:hover {\n  background-color: rgb(31, 188, 176);\n  border-color: rgb(31, 188, 176);\n}\n\n.intake-save a {\n  --brand-red: rgb(223, 79, 60);\n  background-color: var(--brand-red);\n  border-color: var(--brand-red);\n}\n\n.intake-save a:active {\n  --brand-red: rgb(223, 79, 60);\n  background-color: var(--brand-red);\n  border-color: var(--brand-red);\n  filter: brightness(1.05);\n}\n\n.intake-save a:hover {\n  --brand-red: rgb(223, 79, 60);\n  background-color: var(--brand-red);\n  border-color: var(--brand-red);\n  filter: brightness(1.1);\n}\n\n.other a {\n  background-color: rgb(48, 62, 78);\n  border: 1px solid rgb(48, 62, 76);\n}\n\n.other a:active {\n  background-color: rgb(84, 98, 116);\n  border-color: rgb(84, 98, 116);\n}\n\n.other a:hover {\n  background-color: rgb(67, 81, 99);\n  border-color: rgb(67, 81, 99);\n}\n\n.reset a {\n  background-color: rgb(223, 79, 60);\n  border-color: rgb(223, 79, 60);\n}\n\n.reset a:active {\n  background-color: rgb(247, 126, 116);\n  border-color: rgb(247, 126, 116);\n}\n\n.reset a:hover {\n  background-color: rgb(237, 103, 93);\n  border-color: rgb(237, 103, 93);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
